import API from "./API";

export default class Mobs extends API {
  constructor(gateway) {
    super(gateway, 'mob')
  }
}
